import { CanMatchFn, Route, UrlSegment } from '@angular/router';

/** First path segments reserved by the app (not workspace slugs). */
const RESERVED_WORKSPACE_SEGMENTS = new Set(
  [
    'home',
    'signup',
    'login',
    'auth',
    'accept-invite',
    'create-company',
    'create-workspace',
    'select-workspace',
    'onboarding',
    'f',
    'forms',
    'my-forms',
    'dashboard',
    'data-library',
    'people',
    'team-members',
    'integrations',
    'settings',
    'pricing',
    'use-cases',
    'contact-sales',
    'test',
    'api',
    'assets',
    'embed',
    'public',
  ].map((s) => s.toLowerCase()),
);

export const publicFormRouteCanMatch: CanMatchFn = (
  _route: Route,
  segments: UrlSegment[],
) => {
  if (segments.length !== 2) {
    return false;
  }
  const workspaceSlug = segments[0]?.path?.trim().toLowerCase() ?? '';
  const formSlug = segments[1]?.path?.trim().toLowerCase() ?? '';
  if (!workspaceSlug || !formSlug) {
    return false;
  }
  if (RESERVED_WORKSPACE_SEGMENTS.has(workspaceSlug)) {
    return false;
  }
  return true;
};
